import { PreferencesLocalPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const PreferencesLocalPersistenceProvider = createStaticContextProvider(
  PreferencesLocalPersistenceContext,
  lazyValue(() =>
    import("./preferences-local-persistence").then(
      (module) => module.preferencesLocalPersistence,
    ),
  ),
);
